import { AppDispatch } from "@/redux-store";
import { useTranslation } from "react-i18next";

import { tools } from "./types";
import { useEffect, useState } from "react";
import Button from "@/components/Button";
import {
  getUser,
  saveUserSettings,
  UserSettings,
} from "@/database/userDatabaseService";
import { setUser } from "@/redux-store/slices/authReducer";

interface CustomizeToolBoxProps {
  userId: string;
  settings: UserSettings;
  userTools: string[];
  closeModal: () => void;
  dispatch: AppDispatch;
}

export const CustomizeToolBox: React.FC<CustomizeToolBoxProps> = ({
  userId,
  settings,
  userTools,
  closeModal,
  dispatch,
}) => {
  const { t } = useTranslation("translation", { keyPrefix: "settings" });

  const [selectedTools, setSelectedTools] = useState<string[]>(userTools);

  useEffect(() => {
    setSelectedTools(userTools);
  }, [userTools]);

  const setActiveTools = (tool: string) => {
    let tempTools = [...selectedTools]; // selectedTools'un bir kopyasını oluştur
    if (selectedTools?.includes(tool)) {
      tempTools = tempTools.filter((item) => item !== tool);
    } else {
      tempTools = [...tempTools, tool]; // yeni bir dizi oluşturarak tool'u ekliyoruz
    }
    setSelectedTools(tempTools);
  };

  const saveSettings = async () => {
    await saveUserSettings(userId, {
      ...settings,
      selectedTools: selectedTools,
    });

    const user = await getUser();
    dispatch(setUser(user));
  };
  return (
    <div>
      <div className="tool-settings margin-top-10">
        <span>{t("customize_toolbox_content")}</span>
        <div className="tools">
          {tools.map((tool, index) => {
            return (
              <button
                key={`customize-tool-${index}`}
                className={`${
                  selectedTools?.includes(tool.name) ? "active" : ""
                }`}
                onClick={() => setActiveTools(tool.name)}
              >
                {tool.icon}
              </button>
            );
          })}
        </div>
      </div>
      <div className="modal-bottom margin-top-20 flex">
        <Button
          className="obro-light-btn margin-right-10 rounded-btn"
          onClick={() => closeModal()}
        >
          {t("cancel")}
        </Button>
        <Button
          className="obro-secondary-btn rounded-btn"
          onClick={() => {
            saveSettings();
            closeModal();
          }}
        >
          {t("save")}
        </Button>
      </div>
    </div>
  );
};
